const createDataBiHooks = (context, ...hooks) => {
    return hooks.reduce((acc, h) => ({ ...acc, [h]: `${context}-${h}` }), {
        context,
    });
};
export class MutableBiCallbacksState {
    constructor(context, hooks, events) {
        this._callbacks = {};
        this._dataBiHooks = hooks;
        this._events = events;
        this._context = context;
        this._hooks = createDataBiHooks(context, ...(hooks ?? []));
    }
    get hooks() {
        return this._hooks;
    }
    get callbacks() {
        return { ...this._callbacks };
    }
    setCallbacks(newValues) {
        Object.entries(newValues).forEach(([event, callback]) => (this._callbacks[event] = callback));
    }
    withBiHooks(...hooks) {
        return new MutableBiCallbacksState(this._context, hooks, this._events);
    }
    withEvents(...events) {
        return new MutableBiCallbacksState(this._context, this._dataBiHooks, events);
    }
    withMeta() {
        return new MutableBiCallbacksState(this._context, this._dataBiHooks, this._events);
    }
    create() {
        return this;
    }
}
export function createDataBi(context) {
    return new MutableBiCallbacksState(context);
}
//# sourceMappingURL=biUtils.js.map